import React from 'react';

import { retryableLazyImport } from '@/features/app/components/lazy-loader';

export const CreatePipelineStageModal = React.lazy(() =>
  retryableLazyImport(() => import('./create-pipeline-stage-modal'))
);
